export default function CloseIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="close-icon"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 48 48"
    >
      <path
        fill="currentColor"
        d="M24 26.8 13.85 36.95q-.6.6-1.4.6-.8 0-1.4-.6-.6-.6-.6-1.4 0-.8.6-1.4L21.2 24 11.05 13.85q-.6-.6-.6-1.4 0-.8.6-1.4.6-.6 1.4-.6.8 0 1.4.6L24 21.2l10.15-10.15q.6-.6 1.4-.6.8 0 1.4.6.6.6.6 1.4 0 .8-.6 1.4L26.8 24l10.15 10.15q.6.6.6 1.4 0 .8-.6 1.4-.6.6-1.4.6-.8 0-1.4-.6Z"
      />
    </svg>
  );
}
